import React, { useEffect, useState } from "react";
import SidebarLogo from "./Sidebar/SidebarLogo";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Input } from "antd";
import FormItem from "antd/es/form/FormItem";
import { axiosInstance, BASE_API_CONFIG } from "../util/Api";
import { LoginWithVerifyOTP } from "../appRedux/actions";

const LoginWithOtp = () => {
  const history = useHistory();
  const location = useLocation();
  const [form] = Form.useForm();
  const [timer, setTimer] = useState(59);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const mobile = location?.state?.mobile;
  const loading = useSelector(({ common }) => common.loading);
  const otpError = useSelector(({ auth }) => auth.otpError);
  const dispatch = useDispatch();

  useEffect(() => {
    if (otpError) {
      form.setFieldsValue({ otp: "" });
    }
  }, [otpError, form]);

  useEffect(() => {
    if (timer > 0 && isResendDisabled) {
      const countdownInterval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdownInterval);
    } else if (timer === 0) {
      setIsResendDisabled(false);
    }
  }, [timer, isResendDisabled]);
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return `${minutes}:${secondsLeft < 10 ? "0" : ""}${secondsLeft}`;
  };
  const handleResendClick = async () => {
    if (timer !== 0 || !mobile) return;
    try {
      setIsResendDisabled(true);
      setTimer(59);

      await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/auth/whatsapp/login/otp`,
        { mobile }
      );

      console.log("OTP resent successfully");
    } catch (error) {
      console.error("Resend OTP failed", error);
      setIsResendDisabled(false);
    }
  };

  const onFinishFailed = (errorInfo) => {};

  const onFinish = (values) => {
    dispatch(LoginWithVerifyOTP(values?.otp, mobile));
  };

  const handleClick = () => {
    history.push("/signin");
  };

  return (
    <div className="gx-login-container">
      <div style={{ width: "100%", paddingBottom: "40px" }}>
        <SidebarLogo />
      </div>

      <div className="gx-login-content">
        <div className="gx-mb-4">
          <div className="gx-login-header">Login Using Mobile Number</div>
          <p className="gx-login-description">
            {`We have send the whatsapp OTP code to your registered mobile number (${mobile})`}
          </p>
          <p className="gx-login-description">
            Didnt receive the OTP? Wait for {formatTime(timer)} Seconds - &nbsp;{" "}
            <span
              className={`gx-link gx-btn-link ${
                isResendDisabled && "disabled"
              }`}
              onClick={handleResendClick}
            >
              Resend OTP
            </span>
          </p>
        </div>
        <Form
          form={form}
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
        >
          <FormItem
            rules={[{ required: true, message: "Please input your otp!" }]}
            name="otp"
          >
            <Input size="large" maxLength={6} placeholder="OTP" />
          </FormItem>

          <FormItem className="gx-text-center">
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              block
              loading={loading}
            >
              Login with OTP
            </Button>
            <Button onClick={handleClick} type="secondary" size="large" block>
              Back to Login
            </Button>
          </FormItem>
        </Form>
      </div>
    </div>
  );
};

export default LoginWithOtp;
